import env from '../../env';
import { VehicleAvatar as component1 } from './installations/1/index';
import { VehicleAvatar as component2 } from './installations/2/index';
import { VehicleAvatar as component3 } from './installations/3/index';
import { VehicleAvatar as component4 } from './installations/4/index';
import { VehicleAvatar as component6 } from './installations/6/index';
import { VehicleAvatar as component7 } from './installations/7/index';
import { VehicleAvatar as component8 } from './installations/8/index';
import { AppClientId } from '../../modules/Shared/constants';

let component = component1;
switch (env.clientId) {
  case AppClientId.INDEWAL:
    component = component1;
    break;
  case AppClientId.IDWLEASE:
    component = component1;
    break;
  case AppClientId.HARRY_NIJBOER:
    component = component2;
    break;
  case AppClientId.HOOIKAMMER:
    component = component3;
    break;
  case AppClientId.IDW_GMBH:
    component = component4;
    break;
  case AppClientId.AUTOWIENTJES:
    component = component6;
    break;
  case AppClientId.AUTOHUISSALLAND:
    component = component7;
    break;
  case AppClientId.HILTERMANN:
    component = component8;
    break;
  default:
    component = component1;
}

export const VehicleAvatar = component;
